import faker from 'faker';

const StatusAM = [
  {
    name: 'Aguardando autorização',
    data: [{ x: 0, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando documento de cobrança do fornecedor',
    data: [{ x: 1, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando matching financeiro',
    data: [{ x: 2, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'Aguardando pagamento',
    data: [{ x: 3, y: faker.random.number({ min: 10, max: 500 }) }],
  },
  {
    name: 'BM pago',
    visible: false,
    data: [{ x: 4, y: faker.random.number({ min: 10, max: 500 }) }],
  },
];

export default StatusAM;